import { AnalyticsIntegrationJson } from '../../model/interfaces/analytics-integration-json.interface';
import { ProductCaptureData } from '../../model/interfaces/product-capture.interface';

export enum ANALYTICS_SOURCE {
  FVC = 'FVC',
  CLOUD_RISK = 'CLOUD_RISK',
}

export enum ANALYTICS_TYPE {
  FORWARD_TEST = 'FORWARD_TEST',
  VFM_TEST = 'VFM_TEST',
  BACK_TYPE = 'BACK_TYPE',
  PERFORMANCE_TEST = 'PERFORMANCE_TEST',
  SHORTFALL_AND_VAR = 'SHORTFALL_AND_VAR',
  RISK_REWARD = 'RISK_REWARD',
  PRIIPS_SUMMARY = 'PRIIPS_SUMMARY',
  PRIIPS_SCENARIOS = 'PRIIPS_SCENARIOS',
  PRIIPS_COSTS = 'PRIIPS_COSTS',
  FVC_PRIIPS_SUMMARY = 'FVC_PRIIPS_SUMMARY',
  FVC_PRIIPS_SCENARIOS = 'FVC_PRIIPS_SCENARIOS',
  FVC_PRIIPS_COSTS = 'FVC_PRIIPS_COSTS',
}

export enum ANALYTICS_TEST_PROPERTY {
  METRIC = 'metricDescription',
  OUTCOME = 'outcomeDescription',
  TEST = 'testDescription',
  VALUE = 'metricValue',
}

export interface AnalyticsData {
  dateCreated: string;
  dateRetrieved: string;
  description: string;
  source: string;
  tests: AnalyticsTest[];
  type: string;

  id?: number;
  productId?: number;
  reference?: string;
  status?: string;
  internalVersion?: string;
  integrationJsonResult?: AnalyticsIntegrationJson;
  productCaptureDetails?: ProductCaptureData;
}

export interface AnalyticsTest {
  exitAfterRHP?: string;
  exitAfterIHP?: string;
  metricDescription: string;
  outcomeDescription: string;
  testDescription: string;
  metricValue: string;
}

export type TableData =
  | BackTestingTableData
  | ForwardTestingTableData
  | ProbabilityOfReturnsTableData
  | BacktestedProbabilityOfLossTableData
  | ForwardLookingProbabilityOfLossTableData
  | RiskRewardTableData
  | ValueForMoneyFVCTableData
  | ProbabilityOfLossTableData
  | ValueForMoneyCloudRiskTableData
  | PRIIPsSummaryTableData
  | PRIIPsReturnScenariosTableData
  | PRIIPsCostsTableData;

export interface BackTestingTableData {
  outcome?: string;
  average?: string;
  probability?: string;
}

export interface ForwardTestingTableData {
  outcome?: string;
  average?: string;
  probability?: string;
}

export interface ProbabilityOfReturnsTableData {
  outcome?: string;
  historical?: string;
  bear?: string;
  neutral?: string;
  bull?: string;
}

export interface BacktestedProbabilityOfLossTableData {
  outcome?: string;
  last5?: string;
  last10?: string;
  last15?: string;
}

export interface ForwardLookingProbabilityOfLossTableData {
  outcome?: string;
  bear?: string;
  neutral?: string;
  bull?: string;
}

export interface RiskRewardTableData {
  outcome?: string;
  bear?: string;
  neutral?: string;
  bull?: string;
  increase?: string;
  decrease?: string;
  average?: string;
}

export interface ValueForMoneyFVCTableData {
  outcome?: string;
  bear?: string;
  neutral?: string;
  bull?: string;
  decrease?: string;
  increase?: string;
  hurdleRate?: string;
}

export interface ProbabilityOfLossTableData {
  outcome?: string;
  probability?: string;
}

export interface ValueForMoneyCloudRiskTableData {
  outcome?: string;
  probability?: string;
  hurdleRate?: string;
}

export interface PRIIPsSummaryTableData {
  metricDescription?: string;
  metricValue?: string;
}

export interface PRIIPsReturnScenariosTableData {
  testDescription?: string;
  metricDescription?: string;
  exitAfterIHP?: string;
  exitAfterRHP?: string;
}

export interface PRIIPsCostsTableData {
  testDescription?: string;
  exitAfterIHP?: string;
  exitAfterRHP?: string;
}
